module.exports = __webpack_public_path__ + "sx.svg?48d9a6ffe832535649606c8a807ceb9f";